import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { Layout } from '../components/layout/Layout';
import UsuariosTable from '../components/usuarios/UsuariosTable';

const Usuarios: React.FC = () => {
  const { usuario, loading } = useAuth();

  if (loading) {
    return <div>Cargando...</div>;
  }

  // Solo ADMIN pueden ver la página de usuarios
  if (!usuario || usuario.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout>
      <Box sx={{ p: 2 }}>
        <Typography variant="h5" gutterBottom>
          Gestión de Usuarios
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Administra los roles y permisos de los usuarios del sistema
        </Typography>
        <UsuariosTable />
      </Box>
    </Layout>
  );
};

export default Usuarios;